// extracted by mini-css-extract-plugin
module.exports = {"htmlContent":"style_htmlContent___L58i"};